module.exports = __webpack_public_path__ + "static/media/logo-white.d1042bd2.png";